<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>出差</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.beginyears" type="date" placeholder="选择起始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endyears" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="9%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="9%"></el-table-column>
          <el-table-column prop="Ccliyou" label="出差事由" min-width="8%"></el-table-column>
          <el-table-column prop="Ccdays" label="出差天数" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="申请日期" min-width="7%"></el-table-column>
          <el-table-column prop="Ccdaybegin" label="出差开始日期" min-width="6%"></el-table-column>
          <el-table-column prop="Ccdayend" label="出差结束日期" min-width="7%"></el-table-column>
          <el-table-column prop="Ccaddressbegin" label="出差起点" min-width="7%"></el-table-column>
          <el-table-column prop="Ccaddressend" label="出差终点" min-width="7%"></el-table-column>
          <el-table-column prop="Ccbudgetmoney" label="预算总金额" min-width="7%"></el-table-column>
          <el-table-column prop="Ccbudgetdetail" label="预算明细" min-width="7%"></el-table-column>
          <el-table-column prop="Ccbeizhu" label="备注" min-width="12%"></el-table-column>
          <el-table-column prop="Ccstatusname" label="审批状态" min-width="4%"></el-table-column>
          <el-table-column prop="Name1" label="申请人" min-width="4%"></el-table-column>
          <el-table-column prop="Name2" label="部门主管" min-width="4%"></el-table-column>
          <el-table-column prop="Name3" label="副总经理" min-width="4%"></el-table-column>
          <el-table-column prop="Name4" label="总经理" min-width="4%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Ccstatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Ccstatus == 1 && SubRule_ShenPiChuChai_BuMen" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">部门主管审核</el-button>
              <el-button v-if="scope.row.Ccstatus == 2 && SubRule_ShenPiChuChai_DanWei" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Ccstatus == 3 && SubRule_ShenPiChuChai_DanWeiZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe3(scope.row)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请出差" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差事由(必填)</span>
          </label>
          <el-input type="textarea" :rows="3" v-model="addForm.ccliyou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差天数(必填)</span>
          </label>
          <el-input v-model="addForm.ccdays"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差开始日期(必填)</span>
          </label>
          <el-date-picker v-model="addForm.ccdaybegin" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差结束日期(必填)</span>
          </label>
          <el-date-picker v-model="addForm.ccdayend" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差起点(必填)</span>
          </label>
          <el-input v-model="addForm.ccaddressbegin"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差终点(必填)</span>
          </label>
          <el-input v-model="addForm.ccaddressend"></el-input>
        </el-form-item>
        <el-form-item label="预算总金额" class="addAdminForm">
          <el-input v-model="addForm.ccbudgetmoney"></el-input>
        </el-form-item>
        <el-form-item label="预算明细" class="addAdminForm">
          <el-input type="textarea" :rows="3" v-model="addForm.ccbudgetdetail"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" :rows="3" v-model="addForm.ccbeizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyShenPiChuChai',
  data () {
    return {
      activeName: 'first',
      addForm: {
        ccliyou: '',
        ccdays: '',
        ccdaybegin: '',
        ccdayend: '',
        ccaddressbegin: '',
        ccaddressend: '',
        ccbudgetmoney: '0',
        ccbudgetdetail: '无',
        ccbeizhu: '无'
      },
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        beginyears: '',
        endyears: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiChuChaiSHUrl: '',
      ccid: 0,
      SubRule_ShenPiChuChai_BuMen: false,
      SubRule_ShenPiChuChai_DanWei: false,
      SubRule_ShenPiChuChai_DanWeiZong: false
    }
  },
  mounted () {
    this.apiGetShenPiChuChaiNum()
    this.apiGetShenPiChuChaiList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiChuChai_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiChuChai_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiChuChai_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiChuChai_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiChuChai_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiChuChai_DanWeiZong = true
      }
    })

    // this.addForm.ccdaybegin = Vue.prototype.FunGetTimeStringLong()
    // this.addForm.ccdayend = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      this.apiAddShenPiChuChai()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiChuChaiSHUrl = Vue.prototype.global.Url_ShenPiChuChaiSH1
      this.ccid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiChuChaiSHUrl = Vue.prototype.global.Url_ShenPiChuChaiSH2
      this.ccid = row.Id
    },
    ShenHe3 (row) {
      this.dialogVisible = true
      this.apiShenPiChuChaiSHUrl = Vue.prototype.global.Url_ShenPiChuChaiSH3
      this.ccid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiChuChaiSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiChuChaiSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiChuChai(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiChuChaiNum()
      this.apiGetShenPiChuChaiList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiChuChaiList()
    },
    apiGetShenPiChuChaiNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        beginyears: that.keywords.beginyears,
        endyears: that.keywords.endyears
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiChuChaiNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiChuChaiList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        beginyears: that.keywords.beginyears,
        endyears: that.keywords.endyears
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiChuChaiList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiChuChai: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ccliyou: that.addForm.ccliyou,
        ccdays: that.addForm.ccdays,
        ccdaybegin: that.addForm.ccdaybegin,
        ccdayend: that.addForm.ccdayend,
        ccaddressbegin: that.addForm.ccaddressbegin,
        ccaddressend: that.addForm.ccaddressend,
        ccbudgetmoney: that.addForm.ccbudgetmoney,
        ccbudgetdetail: that.addForm.ccbudgetdetail,
        ccbeizhu: that.addForm.ccbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiChuChai, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiChuChaiNum()
            that.apiGetShenPiChuChaiList()

            // 清空添加
            that.addForm.ccliyou = ''
            that.addForm.ccdays = ''
            that.addForm.ccdaybegin = ''
            that.addForm.ccdayend = ''
            that.addForm.ccaddressbegin = ''
            that.addForm.ccaddressend = ''
            that.addForm.ccbudgetmoney = '0'
            that.addForm.ccbudgetdetail = '无'
            that.addForm.ccbeizhu = '无'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiChuChai: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ccid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiChuChai, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiChuChaiNum()
            that.apiGetShenPiChuChaiList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiChuChaiSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ccid: that.ccid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiChuChaiSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiChuChaiNum()
            that.apiGetShenPiChuChaiList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
